import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sent-to-ipx',
  templateUrl: './sent-to-ipx.component.html',
  styleUrls: ['./sent-to-ipx.component.scss']
})
export class SentToIpxComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
